<script lang="ts">
	const { pixelId }: { pixelId?: string } = $props();
</script>

{/* eslint-disable @typescript-eslint/no-unused-expressions */ null}
<svelte:head>
	{#if pixelId}
		{@html `
		<!-- Facebook Pixel Code -->
		<script>
			!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
				n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
				document,'script','//connect.facebook.net/en_US/fbevents.js');

			fbq('init', '${pixelId}');
			fbq('track', "PageView");
		</script>
		<!-- End Facebook Pixel Code -->
		`}
	{/if}
</svelte:head>
{/* eslint-enable @typescript-eslint/no-unused-expressions */ null}
